module.exports = __webpack_public_path__ + "img/tips3list2img19120301.5b896e57.jpg";